<div *ngIf="active.length > 0" class="announcement-region" role="region" [attr.aria-label]="text.regionLabel">
  <div
    *ngFor="let announcement of visibleBanners"
    class="announcement-banner"
    [ngClass]="severityStyles[announcement.severity].bannerClass"
  >
    <thera-header-action-button
      class="announcement-banner-text"
      (clicked)="openDetail(announcement)"
    >
      <svg
        *ngIf="announcement.severity === 'High'"
        class="announcement-banner-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        aria-hidden="true"
      >
        <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
      <svg
        *ngIf="announcement.severity === 'Medium'"
        class="announcement-banner-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="16" x2="12" y2="12" />
        <line x1="12" y1="8" x2="12.01" y2="8" />
      </svg>
      <svg
        *ngIf="announcement.severity === 'Low'"
        class="announcement-banner-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        aria-hidden="true"
      >
        <path d="m3 11 18-5v12L3 14v-3z" />
        <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6" />
      </svg>
      <span class="announcement-banner-message" [innerHTML]="announcement.bannerMessage"></span>
    </thera-header-action-button>
    <thera-header-action-button
      class="announcement-banner-dismiss"
      (clicked)="dismiss(announcement.id)"
    >
      <span aria-hidden="true">&times;</span>
      <span class="announcement-sr-only">{{ text.dismissLabelPrefix + announcement.title }}</span>
    </thera-header-action-button>
  </div>

  <thera-header-action-button
    *ngIf="overflowCount > 0"
    class="announcement-overflow"
    (clicked)="openList()"
  >
    +{{ overflowCount }} {{ text.moreAnnouncement }}{{ overflowCount !== 1 ? 's' : '' }}
  </thera-header-action-button>
</div>


<div
  *ngIf="panelOpen"
  class="announcement-overlay"
  (click)="closePanel()"
></div>

<div class="announcement-slideout" [class.announcement-slideout-open]="panelOpen">
  <ng-container *ngIf="panelMode === 'list'; else detailView">
    <div class="announcement-slideout-header">
      <h2 class="announcement-slideout-title">{{ text.slideoutTitle }}</h2>
    </div>

    <div class="announcement-slideout-body">
      <p *ngIf="active.length === 0" class="announcement-list-empty">
        {{ text.noActiveAnnouncements }}
      </p>
      <ul class="announcement-list" *ngIf="active.length > 0">
        <li *ngFor="let announcement of active" class="announcement-list-item">
          <thera-header-action-button
            class="announcement-list-card"
            (clicked)="selectFromList(announcement.id)"
          >
            <span
              class="announcement-badge"
              [ngClass]="severityStyles[announcement.severity].badgeClass"
            >
              {{ severityStyles[announcement.severity].label }}
            </span>
            <span class="announcement-list-card-title">{{ announcement.title }}</span>
            <span class="announcement-list-card-preview">{{ announcement.preview }}</span>
          </thera-header-action-button>
          <thera-header-action-button
            class="announcement-list-dismiss"
            (clicked)="dismiss(announcement.id)"
          >
            {{ text.dismiss }}
          </thera-header-action-button>
        </li>
      </ul>
    </div>

    <div class="announcement-slideout-footer">
      <span></span>
      <thera-header-action-button class="announcement-slideout-close" (clicked)="closePanel()">
        {{ text.close }}
      </thera-header-action-button>
    </div>
  </ng-container>

  <ng-template #detailView>
    <ng-container *ngIf="selected as announcement">
      <div class="announcement-slideout-header">
        <thera-header-action-button class="announcement-slideout-back" (clicked)="backToList()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14" aria-hidden="true">
            <polyline points="15 18 9 12 15 6" />
          </svg>
          {{ text.backToList }}
        </thera-header-action-button>
        <span
          class="announcement-badge"
          [ngClass]="severityStyles[announcement.severity].badgeClass"
        >
          {{ severityStyles[announcement.severity].label }}
        </span>
        <h2 class="announcement-slideout-title">{{ announcement.title }}</h2>
      </div>

      <div class="announcement-slideout-body" [innerHTML]="announcement.safeContent"></div>

      <div class="announcement-slideout-footer">
        <label class="announcement-slideout-checkbox">
          <input type="checkbox" [(ngModel)]="dontShowAgain" />
          {{ text.dontShowAgain }}
        </label>
        <thera-header-action-button class="announcement-slideout-close" (clicked)="closePanel()">
          {{ text.close }}
        </thera-header-action-button>
      </div>
    </ng-container>
  </ng-template>
</div>
